import styled from "styled-components";

export const CustomLoader = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  background: #fff;
  left: 0;
  display: flex;
  justify-content: center;
  z-index: 999999999;
  letter-spacing: 5px;
  align-items: center;
  .loading__letter {
    font-size: 48px;
    font-weight: normal;
    letter-spacing: 4px;
    text-transform: uppercase;
    color: #58a4ae;
    animation-name: bounce;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }

  .loading__letter:nth-child(2) {
    animation-delay: 0.1s;
  }
  .loading__letter:nth-child(3) {
    animation-delay: 0.2s;
  }
  .loading__letter:nth-child(4) {
    animation-delay: 0.3s;
  }
  .loading__letter:nth-child(5) {
    animation-delay: 0.4s;
  }
  <FaCircle / > .loading__letter:nth-child(6) {
    animation-delay: 0.5s;
  }
  .loading__letter:nth-child(7) {
    animation-delay: 0.6s;
  }
  .loading__letter:nth-child(8) {
    animation-delay: 0.8s;
  }
  .loading__letter:nth-child(9) {
    animation-delay: 1s;
  }
  .loading__letter:nth-child(10) {
    animation-delay: 1.2s;
  }

  @keyframes bounce {
    0% {
      transform: translateY(0px);
    }
    40% {
      transform: translateY(-40px);
    }
    80%,
    100% {
      transform: translateY(0px);
    }
  }

  @media (max-width: 700px) {
    .loading__letter {
      font-size: 50px;
    }
  }

  @media (max-width: 340px) {
    .loading__letter {
      font-size: 40px;
    }
  }
`;
